export class StateCounter {

  #successes: number;
  #errors: number;

  constructor() {
    this.#successes = 0
    this.#errors = 0
  }

  get total() {
    return this.#successes + this.#errors
  }

  get successes() {
    return this.#successes
  }

  get errors() {
    return this.#errors
  }

  success() {
    this.#successes += 1
  }

  error() {
    this.#errors += 1
  }
}
